export default "__VITE_ASSET__BLig8wcC__"